import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';
import SolutionsPage from './pages/SolutionsPage';
import ContactPage from './pages/ContactPage';
import SignupPage from './pages/SignupPage';
import AdminPage from './pages/AdminPage';
import { TermsPage, PrivacyPage, CookiePolicyPage } from './pages/LegalPages';
import FloatingContact from './components/FloatingContact';
import { Toaster } from './components/ui/sonner';
import { I18nProvider } from './i18n/I18nProvider';

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);
  return null;
}

function HideOnAdmin({ children }) {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;
  return children;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <HideOnAdmin><FloatingContact /></HideOnAdmin>
      </BrowserRouter>
      <Toaster position="top-center" />
      </I18nProvider>
    </div>
  );
}

export default App;
